"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = exports.getInitialValues = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _basis = require("basis");

var _components = require("../components");

var _hooks = require("../hooks");

var _types = require("../types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getInitialValues = function getInitialValues(credentials) {
  return credentials.reduce(function (acc, item) {
    var select = item;
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, item.fieldID, item.type === 'select' && select.defaultKey ? select.defaultKey : ''));
  }, {});
};

exports.getInitialValues = getInitialValues;

var Login = function Login() {
  var history = (0, _reactRouter.useHistory)();
  var trackEvent = (0, _hooks.useEventTracker)();
  var institution = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.state.institution;
  });
  var additionalErrorMessage = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.additionalErrorMessage;
  });
  var errorFallbackButton = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.errorFallbackButton;
  });
  var institutionName = (institution === null || institution === void 0 ? void 0 : institution.name) || '';
  var preloadInstitutionSlug = institution !== null && institution !== void 0 && institution.requiresPreload ? institution.slug : '';

  var _useLoginPreload = (0, _hooks.useLoginPreload)(preloadInstitutionSlug),
      preloadData = _useLoginPreload.data,
      preloadComplete = _useLoginPreload.complete,
      preloadError = _useLoginPreload.error;

  var _useLogin = (0, _hooks.useLogin)(),
      loginRequest = _useLogin.request,
      loginError = _useLogin.error,
      loginLoading = _useLogin.loading;

  if (!institution) {
    return null;
  }

  var credentials = preloadInstitutionSlug && preloadData ? preloadData.institution.credentials : institution.credentials;
  var initialValues = getInitialValues(credentials);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
      var outcome, failure, outcomeLoginResponse;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (loginRequest) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return loginRequest(_objectSpread(_objectSpread({
                institution: institution.slug
              }, values), {}, {
                'with-mfa': institution.requiresMfa ? 'with' : 'without'
              }));

            case 4:
              outcome = _context.sent;
              // Handle login error response
              failure = outcome;

              if (!failure.error) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", trackEvent({
                action: 'poi-bank-connect',
                label: 'MFA error'
              }));

            case 8:
              trackEvent({
                action: 'poi-bank-connect',
                label: 'login.buttonSubmit'
              });
              outcomeLoginResponse = outcome;

              if (!(institution.requiresMfa || outcomeLoginResponse.mfa)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", history.push(_types.Routes.mfa, outcome));

            case 12:
              history.push(_types.Routes.accounts);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleGoBack = function handleGoBack() {
    history.goBack();
    trackEvent({
      action: 'poi-bank-connect',
      label: 'login.buttonBack'
    });
  };

  var error = preloadError || loginError;
  return /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_components.Header, {
    error: error === null || error === void 0 ? void 0 : error.error,
    additionalErrorMessage: additionalErrorMessage,
    showSecureMessage: true
  }, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
    path: "login.textTitle",
    vars: {
      institutionName: institutionName
    }
  })), preloadInstitutionSlug && !preloadComplete ? /*#__PURE__*/_react.default.createElement(_components.Loading, {
    text: /*#__PURE__*/_react.default.createElement(_components.TextContent, {
      path: "login.textLoading"
    })
  }) : /*#__PURE__*/_react.default.createElement(_components.LoginForm, {
    initialValues: initialValues,
    loading: loginLoading,
    onSubmit: handleSubmit,
    onGoBack: handleGoBack,
    credentials: credentials
  }), error && errorFallbackButton);
};

exports.Login = Login;